

















































































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../../requester';

import { Paciente } from '../../../../back/src/entity/Paciente';
import { PacientePutFormData } from '../../../../back/src/types';

import Confirmar from '../Confirmar.vue';

export default Vue.extend({
  name: 'ThePacientesDadosFinanceiro',
  props: {
    paciente: {
      type: Object as () => Paciente,
    },
  },
  components: {
    Confirmar,
  },
  data() {
    return {
      loading: false,
      showDadosFinanceiros: true,
      editDadosFinanceiros: false,
      form: {
        dados_financeiros: '',
      },
    };
  },
  mounted() {
    this.form.dados_financeiros = this.paciente.dados_financeiros;
  },
  computed: {
    confirmar(): Vue & { open: (titulo: string, mensagem: string) => boolean } {
      return this.$refs.confirmar as Vue & { open: (titulo: string, mensagem: string) => boolean };
    },
    vRowClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column';
      }
      return '';
    },
    classActions(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex justify-space-between pt-0 pb-2';
      }
      return 'd-flex justify-end pt-0 pb-2';
    },
  },
  methods: {
    // eslint-disable-next-line func-names
    submitFormEditDebounce: _.debounce(async function () { await this.submitFormEdit(); }, 200),
    async submitFormEdit() {
      this.loading = true;
      const formData: PacientePutFormData = {
        id: this.paciente.id,
        dados_financeiros: this.form.dados_financeiros,
      };
      try {
        const response = await Requester.paciente.alteraPaciente(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$emit('atualizaPaciente', response.data);
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Dados atualizados com sucesso!' });
          this.editDadosFinanceiros = false;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
    // eslint-disable-next-line func-names
    desfazerDebounce: _.debounce(async function () { await this.desfazer(); }, 200),
    async desfazer() {
      if (await this.confirmar.open(
        'Desfazer edição',
        'Tem certeza que deseja desfazer a edição?\nOs dados alterados serão perdidos.',
      ) === false) {
        return;
      }
      this.editDadosFinanceiros = false;
    },
  },
});
